import React from "react";
import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { InsertDocumentPopup } from "../../Documents/InsertDocumentPopup.js";
import { ReleaseOrderPopup } from "../../ReleaseOrderPopup/ReleaseOrderPopup.js";
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";
function ClearanceStarredOrdersListing() {
  return (
    <GenericOrdersListing
      title="Starred Orders"
      isReleased={false}
      isCanceled={false}
      readOnly={false}
      icon={AssignmentRoundedIcon}
      InsertDocumentPopup={InsertDocumentPopup}
      ReleaseOrderPopup={ReleaseOrderPopup}
      ChatPopup={ChatPopup}
      showAddOrder={true}
      showAddDocument={true}
      showAddApproval={true}
      showAddInvoice={true}
      showAddCargoX={true}
      showCancelOrder={true}
      showReleaseOrder={true}
      isStarred={true}
    />
  );
}

export default ClearanceStarredOrdersListing;
